import React from 'react';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';
import { MonthlyDoctorsShiftContainer } from './containers';
import '../../../pages/ManagementList.css';

/**
 * 月次医師シフト管理ページ
 *
 * @description
 * 月次医師シフト管理画面のエントリーポイント。
 * LocalizationProviderでラップしてコンテナをレンダリングする。
 *
 * @returns {React.ReactElement} ページコンポーネント
 *
 * @example
 * // App.tsx でのルーティング設定
 * <Route path="/doctors/shifts" element={<MonthlyDoctorsShiftPage />} />
 */
const MonthlyDoctorsShiftPage: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box className="management-page" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* ページタイトル */}
        <div className="management-heading"><div><h1>月次医師シフト管理</h1><p>月ごとの医師シフトを確認・管理します</p></div></div>

        {/* メインコンテンツ */}
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <MonthlyDoctorsShiftContainer />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export { MonthlyDoctorsShiftPage };
